import axios from 'axios'

const { REACT_APP_BUSINESS_API_HOST } = process.env
const businessAxios = axios.create({
  baseURL: REACT_APP_BUSINESS_API_HOST,
})
export const getMenu = () =>
  businessAxios.get('menu/v4.json', {
    params: {
      useOptionalMyMenuList: ['bizwallet', 'company', 'role', 'myasset'],
    },
    paramsSerializer: {
      indexes: null,
    },
  })
